import React from "react";
import colors from "@streeteasy/design-system/deprecated/colors";
import { string } from "prop-types";

const XIcon = props => (
  <svg
    aria-hidden="true"
    height={props.width}
    viewBox="0 0 8 8"
    width={props.width}
  >
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g fill={props.color} transform="translate(-1052.000000, -158.000000)">
        <g transform="translate(1052.000000, 158.000000)">
          <polygon
            points="3.69313131 -1.37353536 4.22646464 -1.37353536 4.22646464 9.29313131 3.69313131 9.29313131"
            transform="translate(3.959798, 3.959798) rotate(45.000000) translate(-3.959798, -3.959798) "
          />
          <polygon
            points="3.69313131 -1.37353536 4.22646464 -1.37353536 4.22646464 9.29313131 3.69313131 9.29313131"
            transform="translate(3.959798, 3.959798) scale(-1, 1) rotate(45.000000) translate(-3.959798, -3.959798) "
          />
        </g>
      </g>
    </g>
  </svg>
);

XIcon.propTypes = {
  /**
   * Optional custom color for the close button, defaults to goatGrey from
   * the StreetEasy color palette.
   */
  color: string,
  /** Give the icon width/height (default is 8px) */
  width: string
};

XIcon.defaultProps = {
  color: colors.goatGrey,
  width: "8px"
};

export default XIcon;
